import { SxProps, Theme } from '@mui/material/styles';

export const itemChangeSX = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: { xs: 0, md: '5px' },
		backgroundColor: 'grey.50',
	},
	btnPriceContainer: { width: '100%', backgroundColor: 'white', px: '10px' },
} satisfies Record<string, SxProps<Theme>>;
